{
  "header": {
    "title": "Historique des questions",
    "description": "Examinez et analysez les réponses précédentes aux retours"
  },
  "emptyState": {
    "company": {
      "title": "Aucune donnée collectée pour le moment",
      "description": "Votre parcours commence ici ! Une fois que les employés auront commencé à partager leurs retours durant le premier mois, vous verrez apparaître des insights et des tendances"
    },
    "directReports": {
      "title": "Aucun subordonné direct",
      "description": "Vous n'avez aucun subordonné direct assigné, mais vous pouvez quand même participer aux enquêtes et partager des retours précieux !",
      "bottomAction": {
        "label": "Si vous pensez qu’il s’agit d’une erreur, contactez votre responsable",
        "helpText": "Texte d’aide"
      }
    }
  },
  "NotEnoughResponse": {
    "title": "Pas encore assez de réponses",
    "description": "Le score sera affiché dès que au moins 3 réponses auront été collectées"
  },
  "tabs": {
    "company": "Entreprise entière",
    "allReports": "Tous les rapports",
    "directReports": "Rapports directs",
    "myTeam": "Mon équipe"
  },
  "leaderDropdown": {
    "triggerLabel": "Leader",
    "searchPlaceholder": "Rechercher un leader"
  },
  "categoryDropdown": {
    "triggerLabel": "Catégories"
  },
  "detailsPage": {
    "header": {
      "description": "Examinez et analysez les réponses précédentes aux retours",
      "exportButton": "Exporter",
      "backButton": "Retour à l'historique des questions"
    },
    "tabs": {
      "company": "Entreprise entière",
      "allReports": "Tous les rapports",
      "directReports": "Rapports directs",
      "myTeam": "Mon équipe"
    },
    "leaderDropdown": {
      "triggerLabel": "Leader",
      "searchPlaceholder": "Rechercher un leader"
    },
    "satisfactionScoreSection": {
      "title": "Score de satisfaction",
      "barChart": {
        "title": "Répartition des réponses",
        "agreeTitle": "D'accord",
        "somewhatAgreeTitle": "Plutôt d'accord",
        "neutralTitle": "Neutre",
        "somewhatDisagreeTitle": "Plutôt pas d'accord",
        "disagreeTitle": "Pas d'accord"
      }
    },
    "directReportSection": {
      "title": "Équipe du rapport direct",
      "empty": {
        "title": "Aucun leader en rapport direct",
        "description": "Ce leader n’a aucun leader subordonné, ou les données ne se sont pas encore chargées."
      }
    },
    "participationRateSection": {
      "title": "Taux de participation"
    },
    "responsesCount_one": "{{count}} réponse",
    "responsesCount_other": "{{count}} réponses",
    "previousResponseSection": {
      "title": "Réponse précédente"
    },
    "enps": {
      "categoryName": "eNPS",
      "questionText": "Quelle est la probabilité que vous recommandiez de travailler pour notre entreprise ?",
      "scoreSection": {
        "title": "Score eNPS",
        "companyAverage": "Moyenne de l’entreprise : {{score}}",
        "tooltip": {
          "description": "L’Employee Net Promoter Score (eNPS) est calculé en interrogeant les employés sur une échelle de 0 à 10 :",
          "promoters": "Promoteurs (9-10)",
          "passives": "Passifs (7-8)",
          "detractors": "Détracteurs (0-6)",
          "formulaLabel": "La formule est :",
          "formula": "% Promoteurs - % Détracteurs = eNPS",
          "resultRange": "Le résultat va de -100 à 100, un score plus élevé étant meilleur. Les passifs sont exclus du calcul final."
        }
      },
      "distribution": {
        "title": "Répartition des réponses",
        "subtitle": "Nombre de réponses",
        "detractors": "Détracteurs ({{percentage}}%)",
        "passives": "Passifs ({{percentage}}%)",
        "promoters": "Promoteurs ({{percentage}}%)",
        "xAxisLabel": "Score de réponse"
      },
      "trendSection": {
        "title": "eNPS au fil du temps",
        "subtitle": "Répartition sur 6 mois",
        "yourTeam": "Votre équipe",
        "companyAverage": "Moyenne de l’entreprise"
      },
      "directReportSection": {
        "title": "Équipe du rapport direct",
        "teamTitle": "Équipe de {{leaderName}}"
      },
      "previousResponseSection": {
        "title": "Réponse précédente",
        "columns": {
          "date": "Date",
          "score": "Score eNPS",
          "responsePercentage": "Pourcentage de réponses"
        }
      }
    }
  }
}
